import { Map } from 'immutable';
import actions from '../actions';

const DEFAULT_STATE = new Map();

function UserEntitiesPermissionReducer(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case actions.SET_USER_ENTITIES_PERMISSIONS:
      return action.permissions;
    default:
      return state;
  }
}

export default UserEntitiesPermissionReducer;
